import PropTypes from "prop-types"

export default PropTypes.shape({
  values: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    formatter: PropTypes.func,
  })),
  summary: PropTypes.number,
})
